// extracted by mini-css-extract-plugin
export default {"container":"DiseaseCard_container__Mb5k+","content":"DiseaseCard_content__CBswi"};